export const DIC = {
  SEX: [
    {
      label: "男",
      value: "MALE",
      color: "green",
    },
    {
      label: "女",
      value: "FEMALE",
      color: "red",
    },
  ],
  DELIVERY_ORDER_STATUS: [
    {
      label: "待提货",
      value: "WAIT_FOR_DELIVERY",
    },
    {
      label: "待安装",
      value: "WAIT_INSTALL",
    },
    {
      label: "已安装",
      value: "INSTALLED",
    },
    {
      label: "待指派",
      value: "WAIT_FOR_ASSIGN",
    },
  ],
  ORDER_CEILING_STATUS: [
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "待指派",
      value: "WAIT_FOR_ASSIGN",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "待提货",
      value: "WAIT_FOR_DELIVERY",
    },
    {
      label: "待安装",
      value: "WAIT_INSTALL",
    },
    {
      label: "部分安装",
      value: "PARTIAL_INSTALLATION",
    },
    {
      label: "延迟安装",
      value: "NOT_INSTALLED",
    },
    {
      label: "已退回",
      value: "BACK",
    },
    {
      label: "待评价",
      value: "TO_BE_EVALUATED",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
  ],
  PURE_OR_PROOF: [
    {
      label: "净水",
      value: "PURE_WATER",
    },
    {
      label: "防水",
      value: "WATERPROOF",
    },
    {
      label: "工程",
      value: "ENGINEERING",
    },
    {
      label: "吊顶",
      value: "HANG_CEILING",
    },
  ],
  WALLET_DEPOSIT_AUDIT: [
    {
      label: "提交平台处理",
      value: "SUBMIT_APPLICATION",
    },
    {
      label: "已提交银行处理",
      value: "SUBMISSION_OF_BANKING",
    },
    {
      label: "已提现",
      value: "HAVE_WITHDRAWAL",
    },
    {
      label: "驳回",
      value: "REJECT",
    },
    {
      label: "平台处理中",
      value: "WAIT_AUDIT",
    },
  ],
  WALLET_DEPOSIT_STATUS: [
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "异常",
      value: "ABNORMAL",
    },
    {
      label: "待标记",
      value: "WAIT_SIGN",
    },
  ],
  WMC_CHECK_STATUS: [
    {
      label: "审核通过",
      value: "SUCCESS",
    },
    {
      label: "审核失败",
      value: "FAILED",
    },
  ],
  JOB_STATUS: [
    {
      label: "在职",
      value: "ON_JOB",
    },
    {
      label: "离职",
      value: "DISMISSION",
    },
    {
      label: "实习期",
      value: "INTERNSHIP",
    },
  ],
  CHANGE_TYPE: [
    {
      label: "离职",
      value: "DISMISSION",
    },
    {
      label: "转正",
      value: "ON_JOB",
    },
    {
      label: "调岗",
      value: "TRANSFER_POSITION",
    },
    {
      label: "新入职",
      value: "NEW_RECRUITS ",
    },
  ],
  REDPACKET_STATUS: [
    {
      label: "未开始",
      value: "NOT_BEGIN ",
    },
    {
      label: "进行中",
      value: "UNDER_WAY",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
  ],
  PAY_STATUS: [
    {
      label: "已支付",
      value: "PAY_SUCCESS",
    },
    {
      label: "未支付",
      value: "WAIT_PAY",
    },
  ],
  PAYMENT: [
    {
      label: "定额领取",
      value: "QUOTA_RECEIVE",
    },
    {
      label: "随机领取",
      value: "RANDOM_COLLECTION",
    },
  ],
  REDPACKET_TYPE: [
    {
      label: "已领取",
      value: "ALREADY_RECEIVED",
    },
    {
      label: "未领取",
      value: "UNCLAIMED",
    },
  ],
  TAGS_CLIENT_TYPE: [
    {
      label: "工程师端",
      value: "JOINS_ENGINEER",
    },
    {
      label: "商户端",
      value: "JOINS_MERCHANT",
    },
    {
      label: "推广员端",
      value: "JOINS_PROMOTION_SPECIALIST",
    },
  ],
  CLIENT_TYPE: [
    {
      label: "工程师端",
      value: "JOINS_ENGINEER",
    },
    {
      label: "消费者端",
      value: "JOINS_USER",
    },
    {
      label: "商户端",
      value: "JOINS_MERCHANT",
    },
    {
      label: "代理商",
      value: "JOINS_AGENT",
    },
    {
      label: "后台管理",
      value: "JOINS_SYSTEM_MANAGE",
    },
    {
      label: "小程序推广专员",
      value: "JOINS_PROMOTION_SPECIALIST",
    },
  ],
  PRE_FILTER_SOURCE: [
    {
      label: "平台",
      value: "JOINS_SYSTEM_MANAGE",
    },
    {
      label: "代理商",
      value: "JOINS_AGENT",
    },
  ],
  STEP_TYPE: [
    {
      label: "正常状态",
      value: "STATUS",
    },
    {
      label: "初始状态",
      value: "INIT_STATUS",
    },
    {
      label: "无效状态",
      value: "INVALID_STATUS",
    },
    {
      label: "OPTION操作/按钮",
      value: "OPTION",
    },
  ],
  STATUS_TYPE: [
    {
      label: "前进",
      value: "FORWARD",
    },
    {
      label: "后退",
      value: "BACK",
    },
  ],
  DELETE_FLAG: [
    {
      label: "是",
      value: "YES",
      color: "red",
    },
    {
      label: "否",
      value: "NO",
      color: "green",
    },
  ],
  ENABLE: [
    {
      label: "是",
      value: "YES",
      color: "red",
    },
    {
      label: "否",
      value: "NO",
      color: "green",
    },
  ],
  YES_NO: [
    {
      label: "是",
      value: "YES",
    },
    {
      label: "否",
      value: "NO",
    },
  ],
  CUSTOMER_STATUS_USER_TYPE: [
    {
      label: "客户",
      value: "CUSTOMER",
    },
    {
      label: "员工",
      value: "STUFF",
    },
  ],
  LICENSE_TYPE: [
    {
      label: "营业执照",
      value: "BUSINESS",
    },
    {
      label: "其他",
      value: "OTHER",
    },
  ],
  DELETE_OPTION: [
    {
      label: "逻辑删除",
      value: "LOGICAL",
    },
    {
      label: "物理删除",
      value: "PHYSICAL",
    },
  ],
  GOODS_STATUS: [
    {
      label: "上架",
      value: "SOLD_IN",
    },
    {
      label: "下架",
      value: "SOLD_OUT",
    },
  ],
  REQUEST_METHOD: [
    {
      label: "GET",
      value: "GET",
    },
    {
      label: "POST",
      value: "POST",
    },
    {
      label: "PUT",
      value: "PUT",
    },
    {
      label: "DELETE",
      value: "DELETE",
    },
  ],
  MENU_TYPE: [
    {
      label: "目录",
      value: "DIRECTORY",
    },
    {
      label: "菜单",
      value: "MENU",
    },
    {
      label: "按钮",
      value: "OPERATION",
    },
  ],
  STATUS_STATE_MODEL: [
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "无效",
      value: "INVALID",
    },
  ],
  SHOP_APPROVE_STATUS: [
    {
      label: "正常",
      value: "SUCCESS",
    },
    {
      label: "无效",
      value: "FAILED",
    },
    {
      label: "待审核",
      value: "WAIT_APPROVE",
    },
  ],
  POINTS_DETAIL_STATUS: [
    {
      label: "成功",
      value: "SUCCESS",
    },
    {
      label: "失败",
      value: "FAILED",
    },
    {
      label: "待审核",
      value: "WAIT_APPROVE",
    },
  ],
  POINTS_RULE_TYPE: [
    {
      label: "奖励",
      value: "AWARD",
    },
    {
      label: "惩罚",
      value: "PUNISHMENT",
    },
  ],
  STATE: [
    {
      label: "正常",
      value: "NORMAL",
      color: "green",
    },
    {
      label: "无效",
      value: "INVALID",
      color: "red",
    },
  ],
  productType: [
    {
      label: "辅材",
      value: 1,
    },
    {
      label: "扣板",
      value: 2,
    },
    {
      label: "电器",
      value: 3,
    },
  ],
  GRADE: [
    {
      label: "管理员",
      value: 0,
    },
    {
      label: "二级管理员",
      value: 1,
    },
  ],
  SYSTEM_TYPE: [
    {
      label: "后台管理",
      value: "BG_SYSTEM",
    },
    {
      label: "应用服务",
      value: "APPS",
    },
  ],
  PERMISSION_TYPE: [
    {
      label: "目录",
      value: "DIRECTORY",
    },
    {
      label: "菜单",
      value: "MENU",
    },
    {
      label: "按钮",
      value: "OPERATION",
    },
    {
      label: "系统",
      value: "SYSTEM",
    },
  ],
  DISTRIBUTION_MODE: [
    {
      label: "自提",
      value: "SELF_MENTION",
    },
    {
      label: "配送",
      value: "DELIVERY",
    },
  ],
  SUPPLY_LIST_STATUS: [
    {
      label: "待确认",
      value: "TO_BE_CONFIRMED",
    },
    {
      label: "备货中",
      value: "STOCK_UP",
    },
    {
      label: "待提货",
      value: "WAITING_DELIVERY",
    },
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "待配送",
      value: "TO_BE_DELIVERED",
    },
    {
      label: "配送中",
      value: "DISTRIBUTION",
    },
    {
      label: "待收货",
      value: "TO_BE_RECEIVED",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
  ],
  DISTRIBUTION_SHEET_STATUS: [
    {
      label: "待受理",
      value: "WAIT_ACCEPTED",
    },
    {
      label: "待配送",
      value: "TO_BE_DELIVERED",
    },
    {
      label: "配送中",
      value: "DISTRIBUTION",
    },
    {
      label: "待收货",
      value: "TO_BE_RECEIVED",
    },
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
  ],
  // eslint-disable-next-line no-dupe-keys
  YES_NO: [
    {
      label: "是",
      value: "YES",
    },
    {
      label: "否",
      value: "NO",
    },
  ],
  QR_STATUS: [
    {
      label: "进行中",
      value: "GOING",
    },
    {
      label: "已使用",
      value: "YESGET",
    },
    {
      label: "未开始",
      value: "DNS",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "已失效",
      value: "EXPIRE",
    },
  ],
  WORK_ORDER_STATUS: [
    {
      label: "待派发",
      value: "WAIT_DISTRIBUTE",
    },
    {
      label: "待受理",
      value: "WAIT_ACCEPT",
    },
    {
      label: "待服务",
      value: "FOR_SERVICE",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "待审核",
      value: "TO_BE_CONFIRMED",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "待评价",
      value: "TO_EVALUATE",
    },
    {
      label: "已完成",
      value: "SOLVE",
    },
    {
      label: "已完成",
      value: "WORK_ORDER_STATUS",
    },
    {
      label: "失效",
      value: "INVALID",
    },
    {
      label: "行进中",
      value: "ENGINEER_ON_THE_WAY",
    },
  ],
  WORK_PROJECT_SERVICE: [
    {
      label: "待派发",
      value: "WAIT_DISTRIBUTE",
    },
    {
      label: "待受理",
      value: "WAIT_ACCEPT",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "未完成",
      value: "UNFINISH",
    },
    {
      label: "完成",
      value: "FINISH",
    },
  ],
  SALES_RED_PACKED_PAYMENT: [
    {
      label: "随机领取",
      value: "RANDOM_COLLECTION",
    },
    {
      label: "批量随机领取",
      value: "BATCH_RANDOM_COLLECTION",
    },
    {
      label: "定额领取",
      value: "QUOTA_RECEIVE",
    },
    {
      label: "批量定额领取",
      value: "BATCH_QUOTA_RECEIVE",
    },
  ],
  SALES_RED_PACKED_TYPE: [
    {
      label: "现金红包",
      value: "CASH",
    },
    {
      label: "积分红包",
      value: "INTEGRAL",
    },
  ],
  CLEARING_TYPE: [
    {
      label: "手动",
      value: "HAND",
    },
    {
      label: "自动",
      value: "AUTO",
    },
  ],
  CLEARING_STATUS_TYPE: [
    {
      label: "已结算",
      value: "PAID",
    },
    {
      label: "待结算",
      value: "NOT_PAID",
    },
    {
      label: "客户已退货",
      value: "CANCAL",
    },
  ],
  SALES_RED_PACKED_STATUS: [
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
    {
      label: "待审核",
      value: "TO_AUDIT",
    },
    {
      label: "未开始",
      value: "NOT_BEGIN",
    },
    {
      label: "进行中",
      value: "UNDER_WAY",
    },
    {
      label: "已过期",
      value: "OUT_OF_DATE",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "禁用",
      value: "DISABLE",
    },
  ],
  SCAN_RED_STATUS: [
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
    {
      label: "待审核",
      value: "TO_AUDIT",
    },
    {
      label: "未开始",
      value: "NOT_BEGIN",
    },
    {
      label: "进行中",
      value: "UNDER_WAY",
    },
    {
      label: "已过期",
      value: "OUT_OF_DATE",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "禁用",
      value: "DISABLE",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
  ],
  PRE_FILTER_STATUS: [
    {
      label: "待受理",
      value: "WAIT_ACCEPT",
    },
    {
      label: "待提货",
      value: "WAIT_FOR_DELIVERY",
    },
    {
      label: "待终审",
      value: "WAIT_AUDIT",
    },
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "已完成",
      value: "DONE",
    },
    {
      label: "待派发",
      value: "WAIT_DISTRIBUTE",
    },
    {
      label: "待派发",
      value: "WAIT_FOR_ASSIGN",
    },
    {
      label: "待服务",
      value: "FOR_SERVICE",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "待用户确认",
      value: "TO_BE_CONFIRMED",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
    {
      label: "待评价",
      value: "TO_EVALUATE",
    },
    {
      label: "待评价",
      value: "TO_BE_EVALUATED",
    },
    {
      label: "已完成",
      value: "SOLVE",
    },
    {
      label: "失效",
      value: "INVALID",
    },
    {
      label: "行进中",
      value: "ENGINEER_ON_THE_WAY",
    },
    {
      label: "已退回",
      value: "HAS_BEEN_RETURNED_USER",
    },
    {
      label: "已退回",
      value: "HAS_BEEN_RETURNED_USER_PLATFORM",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
  ],
  AFTER_SALES_STATUS: [
    {
      label: "待派发",
      value: "WAIT_FOR_ASSIGN",
    },
    {
      label: "待受理",
      value: "WAIT_ACCEPT",
    },
    {
      label: "待提货",
      value: "WAIT_FOR_DELIVERY",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
    {
      label: "待评价",
      value: "TO_EVALUATE",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
  ],
  CHECK_STATUS: [
    {
      label: "未确认",
      value: "UNCONFIRMED",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "已主动确认",
      value: "ACTIVECONFIRM",
    },
    {
      label: "已自动确认",
      value: "AUTOCONFIRM",
    },
    {
      label: "待发送",
      value: "UNSENT",
    },
  ],
  WALLET_DEPOSIT_TAKE_TYPE: [
    {
      label: "银行卡",
      value: "BANK",
    },
    {
      label: "微信零钱",
      value: "WE_CHAT",
    },
  ],
  DELIVERY_TYPE: [
    {
      label: "快递",
      value: "EXPRESS",
    },
    {
      label: "商家配送",
      value: "MERCHANT",
    },
  ],
  ORDER_STATUS: [
    {
      label: "失效",
      value: "INVALID",
    },
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
    {
      label: "待发货",
      value: "WAIT_SEND",
    },
    {
      label: "待确认",
      value: "WAIT_CONFIRM",
    },
    {
      label: "完成",
      value: "FINISH",
    },
    {
      label: "关闭订单",
      value: "CLOSED",
    },
  ],

  SNAP_ORDER_STATUS: [
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "已付款",
      value: "ALREADY_PAY",
    },
    {
      label: "完成",
      value: "FINISHED",
    },
    {
      label: "失效",
      value: "INVALID",
    },
  ],
  CONTRAST: [
    {
      label: "大于",
      value: "ET",
    },
    {
      label: "小于",
      value: "LT",
    },
    {
      label: "等于",
      value: "EQ",
    },
    {
      label: "小于等于",
      value: "LE",
    },
    {
      label: "大于等于",
      value: "GE",
    },
  ],
  PARAMETERS: [
    {
      label: "团队周接单数",
      value: "TEAM_WEEKLY_ORDERS",
    },
    {
      label: "团队月接单数",
      value: "TEAM_MONTHLY_ORDERS",
    },
  ],
  EXIT_RULE_STATUS: [
    {
      label: "已启动",
      value: "START",
    },
    {
      label: "已暂停",
      value: "STOP",
    },
    {
      label: "已删除",
      value: "DELETE",
    },
  ],
  RULE_PARAMETERS: [
    {
      label: "工程师活跃天数",
      value: "ACTIVE_DAY",
    },
    {
      label: "工程师接单数",
      value: "ORDER_RECEIVING",
    },
  ],
  MESSAGE_STATUS: [
    {
      label: "待发送",
      value: "WAIT_SEND",
    },
    {
      label: "已失败",
      value: "FAILED_SEND",
    },
    {
      label: "已发送",
      value: "SUCCEED_SEND",
    },
  ],
  TEAM_STATUS: [
    {
      label: "组团中",
      value: "UNDERWAY",
    },
    {
      label: "解散",
      value: "DISSOLVE",
    },
    {
      label: "冻结",
      value: "FREEZE",
    },
  ],
  EXIT_RULE_CONTRAST: [
    {
      label: "大于",
      value: "ET",
    },
    {
      label: "小于",
      value: "LT",
    },
  ],
  RULE_CONTRAST: [
    {
      label: "大于",
      value: "ET",
    },
    {
      label: "小于",
      value: "LT",
    },
  ],
  FINANCIAL_TYPE: [
    {
      label: "收入 ",
      value: "INCOME",
    },
    {
      label: "支出",
      value: "EXPEND",
    },
  ],
  FINANCIAL_SOURCE: [
    {
      label: "红包 ",
      value: "RED_PACKET",
    },
    {
      label: "积分商城",
      value: "POINTS_MALL",
    },
    {
      label: "工单",
      value: "WORK_ORDER",
    },
    {
      label: "提现",
      value: "WITHDRAW_DEPOSIT",
    },
    {
      label: "余额充值",
      value: "WALLET_RECHARGE",
    },
    {
      label: "进货单",
      value: "SUPPLY_LIST",
    },
    {
      label: "配送费",
      value: "DISTRIBUTION_FEE",
    },
    {
      label: "工友圈帖子打赏募捐",
      value: "WMC_REWARD",
    },
    {
      label: "退货单退款",
      value: "RETURN_ORDER",
    },
    {
      label: "手动添加",
      value: "MANUAL_AMOUNT",
    },
    {
      label: "抵用券支付",
      value: "VOUCHER",
    },
    {
      label: "抢购商品订单支付",
      value: "RUSH_BUY_ORDER",
    },
    {
      label: "商品二维码",
      value: "PRE_FILTER",
    },
    {
      label: "推广费",
      value: "PROMOTE",
    },
    {
      label: "产品订单",
      value: "PRODUCT_ORDER",
    },
    {
      label: "抢购订单",
      value: "SNAP_ORDER",
    },
    {
      label: "采购订单",
      value: "PURCHASE_ORDER",
    },
    {
      label: "销售订单",
      value: "SELL_ORDER",
    },
    {
      label: "商品入库",
      value: "GOODS_STOCK",
    },
    {
      label: "押金",
      value: "PLEDGE",
    },
    {
      label: "商户采购",
      value: "MERCHANT_PROCUREMENT",
    },
  ],
  PRODUCT_STATUS: [
    {
      label: "上架",
      value: "PUTAWAY",
    },
    {
      label: "进行中",
      value: "ING",
    },
    {
      label: "下架",
      value: "UNDERCARIAGE",
    },
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
    {
      label: "未通过",
      value: "FAILED",
    },
  ],
  PRODUCT_WAREHOUSING_STATUS: [
    {
      label: "上架",
      value: "PUTAWAY",
    },
    {
      label: "下架",
      value: "UNDERCARIAGE",
    },
  ],
  INVOICE_SYSTEN_PUT_STATUS: [
    {
      label: "上架",
      value: "SOLD_IN",
    },
    {
      label: "下架",
      value: "SOLD_OUT",
    },
  ],
  PRODUCT_ORDER_TYPE: [
    {
      label: "正常售卖",
      value: "SELL",
    },
    {
      label: "秒杀",
      value: "SECKILL",
    },
    {
      label: "团购",
      value: "GROUP_BUY",
    },
  ],
  PRODUCT_SHARE_TYPE: [
    {
      label: "分享产品",
      value: "SELL",
    },
    {
      label: "分享秒杀",
      value: "SECKILL",
    },
    {
      label: "分享优惠券",
      value: "COUPON",
    },
    {
      label: "分享团购",
      value: "GROUP_BUY",
    },
  ],
  PRODUCT_GOODS_STATUS: [
    {
      label: "售卖中",
      value: "PUTAWAY",
    },
    {
      label: "未售卖",
      value: "UNDERCARIAGE",
    },
  ],
  PRODUCT_GROUP_GOODS_STATUS: [
    {
      label: "进行中",
      value: "ING",
    },
    {
      label: "未开始",
      value: "NOT_BEGIN",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "已取消",
      value: "CANCEL",
    },
  ],
  PRODUCT_GROUP_ORDER_STATUS: [
    {
      label: "待成团",
      value: "WAIT_GROUP",
    },
    {
      label: "待退款",
      value: "WAIT_REFUND",
    },
    {
      label: "已退款",
      value: "REFUND",
    },
    {
      label: "已成团",
      value: "FINISH",
    },
  ],

  FINANCIAL_STATUS: [
    {
      label: "现款现货",
      value: "CASH",
    },
    {
      label: "月结",
      value: "INSTALLMENT",
    },
  ],
  WALLET_ABLE: [
    {
      label: "允许提现",
      value: "YES",
    },
    {
      label: "不允许提现",
      value: "NO",
    },
  ],
  VIDEO_STATUS: [
    {
      label: "转码中",
      value: "TRANSCODING",
    },
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "下架",
      value: "HIDE",
    },
    {
      label: "违规删除",
      value: "ILLEGAL",
    },
  ],
  WALLET_USER_TYPE: [
    {
      label: "消费者",
      value: "JOINS_USER",
    },
    {
      label: "服务工程师",
      value: "JOINS_ENGINEER",
    },
    {
      label: "推广员",
      value: "JOINS_PROMOTION_SPECIALIST",
    },
    {
      label: "商户",
      value: "JOINS_MERCHANT",
    },
  ],
  SERVICEITEM_PAYER: [
    {
      label: "预约人",
      value: "RESERVATION",
    },
    {
      label: "服务商",
      value: "AGENT",
    },
  ],
  SERVICEITEM_TYPE: [
    {
      label: "慧家助手",
      value: "JOINS_USER",
    },
    {
      label: "监理",
      value: "JOINS_ENGINEER",
    },
    {
      label: "慧家云",
      value: "JOINS_AGENT",
    },
    {
      label: "慧家商户",
      value: "JOINS_MERCHANT",
    },
  ],
  CUSTOMER_USER_TYPE: [
    {
      label: "消费者",
      value: "JOINS_USER",
    },
    {
      label: "服务工程师",
      value: "JOINS_ENGINEER",
    },
    {
      label: "内部员工",
      value: "JOINS_EMPLOYEE",
    },
  ],

  COMMERCE_GOODS: [
    {
      label: "售卖中",
      value: "SELL",
    },
    {
      label: "秒杀中",
      value: "SECKILL",
    },
    {
      label: "未售卖",
      value: "NOT_SELL",
    },
    {
      label: "团购中",
      value: "GROUP_BUY",
    },
  ],

  WALLET_RECHARGE_WAY: [
    {
      label: "账户余额",
      value: "BALANCE",
    },
    {
      label: "微信支付",
      value: "WX_PAY",
    },
  ],

  STOCK_AR_STATUS: [
    {
      label: "未收款",
      value: "UNCOLLECTED",
    },
    {
      label: "已收款",
      value: "RECEIPT",
    },
  ],
  NEW_STOCK_AR_STATUS: [
    {
      label: "未收款",
      value: "NO",
    },
    {
      label: "已收款",
      value: "YES",
    },
  ],
  STOCK_PAYMENT_STATUS: [
    {
      label: "未付款",
      value: "NON_PAY",
    },
    {
      label: "已付款",
      value: "SPEND",
    },
  ],
  EXIT_STATUS: [
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "已完成",
      value: "DONE",
    },
  ],
  SALES_STATUS: [
    {
      label: "进行中",
      value: "UNDER_WAY",
    },
    {
      label: "已取消",
      value: "CANCEL",
    },
    {
      label: "已下架",
      value: "DOWN",
    },
  ],
  STOCK_REMOVAL_PAY_STATUS: [
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
    {
      label: "已完成",
      value: "FINISH",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "待退款",
      value: "WAIT_REFUND",
    },
    {
      label: "已失效",
      value: "INVALID",
    },
  ],
  STOCK_REFUND_STATUS: [
    {
      label: "已完成",
      value: "FINISH",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
  ],
  STOCK_REMOVAL_STATUS: [
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "待出库",
      value: "WAIT_OUT",
    },
    {
      label: "待收货",
      value: "WAIT_CONFIRM",
    },
    {
      label: "待退款",
      value: "WAIT_REFUND",
    },
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
    {
      label: "已完成",
      value: "FINISH",
    },
    {
      label: "已退回",
      value: "RETURNED",
    },
    {
      label: "已失效",
      value: "INVALID",
    },
    {
      label: "已取消",
      value: "CANCELED",
    },
  ],
  BANK_LIST: [
    {
      label: "中国工商银行",
      value: "中国工商银行",
    },
    {
      label: "中国农业银行",
      value: "中国农业银行",
    },
    {
      label: "中国建设银行",
      value: "中国建设银行",
    },
    {
      label: "中国银行",
      value: "中国银行",
    },
    {
      label: "中国农业发展银行",
      value: "中国农业发展银行",
    },
    {
      label: "中国民生银行",
      value: "中国民生银行",
    },
    {
      label: "中信银行",
      value: "中信银行",
    },
    {
      label: "四川农信银行",
      value: "四川农信银行",
    },
    {
      label: "交通银行",
      value: "交通银行",
    },
    {
      label: "成都银行",
      value: "成都银行",
    },
    {
      label: "招商银行",
      value: "招商银行",
    },
    {
      label: "汇丰银行",
      value: "汇丰银行",
    },
    {
      label: "华夏银行",
      value: "华夏银行",
    },
    {
      label: "恒丰银行",
      value: "恒丰银行",
    },
    {
      label: "兰州银行",
      value: "兰州银行",
    },
    {
      label: "攀枝花银行",
      value: "攀枝花银行",
    },
    {
      label: "遂宁银行",
      value: "遂宁银行",
    },
    {
      label: "自贡市商业银行",
      value: "自贡市商业银行",
    },
    {
      label: "南充市商业银行",
      value: "南充市商业银行",
    },
    {
      label: "泸州市商业银行",
      value: "泸州市商业银行",
    },
    {
      label: "绵阳市商业银行",
      value: "绵阳市商业银行",
    },
    {
      label: "重庆银行",
      value: "重庆银行",
    },
    {
      label: "重庆三峡银行",
      value: "重庆三峡银行",
    },
    {
      label: "中国光大银行",
      value: "中国光大银行",
    },
    {
      label: "南京银行",
      value: "南京银行",
    },
    {
      label: "上海浦东发展银行",
      value: "上海浦东发展银行",
    },
    {
      label: "深圳发展银行",
      value: "深圳发展银行",
    },
    {
      label: "广东发展银行",
      value: "广东发展银行",
    },
    {
      label: "广东农信银行",
      value: "广东农信银行",
    },
    {
      label: "广州银行",
      value: "广州银行",
    },
    {
      label: "浙商银行",
      value: "浙商银行",
    },
    {
      label: "浙江民泰商业银行",
      value: "浙江民泰商业银行",
    },
  ],
  PAY_TYPE: [
    {
      label: "账户余额",
      value: "BALANCE",
    },
    {
      label: "微信支付",
      value: "WX_PAY",
    },
    {
      label: "线下汇款",
      value: "OFFLINE_REMIT",
    },
    {
      label: "平台支付",
      value: "PLATFORM_PAY",
    },
  ],
  OPERATION_TYPE: [
    {
      label: "充值",
      value: "WALLET_RECHARGE",
    },
    {
      label: "添加钱包金额",
      value: "MANUAL_AMOUNT",
    },
    {
      label: "提现",
      value: "PURCHASE_ORDER",
    },
  ],
  UNFREEZE_APPLY_STATUS: [
    {
      label: "冻结中",
      value: "FREEZING",
    },
    {
      label: "可解冻",
      value: "UNFREEZABLE",
    },
    {
      label: "已拒绝",
      value: "REFUSED",
    },
    {
      label: "审核中",
      value: "AUDIT",
    },
    {
      label: "已退还",
      value: "RETURNED",
    },
  ],
  SHIPMENT_STATUS: [
    {
      label: "已出货",
      value: "ALREADY",
    },
    {
      label: "未出货",
      value: "UNRIPE",
    },
    {
      label: "已入库",
      value: "RECEIVED",
    },
    {
      label: "自动入库",
      value: "AUTO_RECEIVED",
    },
  ],
  ORDER_MANGEMENT_STATUS: [
    {
      label: "待支付",
      value: "WAIT_PAY",
    },
    {
      label: "待发货",
      value: "WAIT_SHIPPED",
    },
    {
      label: "配送中",
      value: "IN_DELIVERY",
    },
    {
      label: "已完成",
      value: "FINISH",
    },
  ],

  CASH_WITHDRAWAL_STATUS: [
    {
      label: "用户提交提现申请",
      value: "SUBMIT_APPLICATION",
    },
    {
      label: "已提交银行处理",
      value: "SUBMISSION_OF_BANKING",
    },
    {
      label: "已提现",
      value: "HAVE_WITHDRAWAL",
    },
    {
      label: "驳回",
      value: "REJECT",
    },
  ],
  CASH_STATUS: [
    {
      label: "待处理",
      value: "WAIT_HANDLE",
    },
    {
      label: "已完成",
      value: "FINISH",
    },
    {
      label: "已拒绝",
      value: "REFUSED",
    },
  ],
  PRODUCT_COUPON_DETAIL_STATUS: [
    {
      label: "已领取",
      value: "RECEIVED",
    },
    {
      label: "已使用",
      value: "USED",
    },
    {
      label: "已过期",
      value: "EXPIRED",
    },
    {
      label: "禁用",
      value: "INVALID",
    },
  ],
  PRODUCT_COUPON_USE_STATUS: [
    {
      label: "未开始",
      value: "NOT_BEGIN",
    },
    {
      label: "未使用",
      value: "UNUSED",
    },
    {
      label: "已使用",
      value: "USED",
    },
    {
      label: "已过期",
      value: "EXPIRED",
    },
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
  ],
  SALES_RED_PACKED_DETAIL_STATUS: [
    {
      label: "已领取",
      value: "ALREADY_RECEIVED",
    },
    {
      label: "未领取",
      value: "UNCLAIMED",
    },
  ],
  PROMOTE_TYPE: [
    {
      label: "定额",
      value: "MONEY",
    },
    {
      label: "百分比",
      value: "PERCENT",
    },
  ],
  PRODUCT_COUPON_STATUS: [
    {
      label: "未开始",
      value: "NOT_BEGIN",
    },
    {
      label: "进行中",
      value: "UNDER_WAY",
    },
    {
      label: "已结束",
      value: "OVER",
    },
    {
      label: "禁用",
      value: "DISABLE",
    },
  ],
  CHANNEL_TYPE: [
    {
      label: "新用户首次登录",
      value: "LOGIN",
    },
    {
      label: "用户登录",
      value: "USER_LOGIN",
    },
    {
      label: "工单完成支付",
      value: "WORK_ORDER",
    },
    {
      label: "购买商品",
      value: "PURCHASE_GOODS",
    },
    {
      label: "推广用户",
      value: "PROMOTING_USERS",
    },
  ],
  SERVICEITEM_AUDITOR: [
    {
      label: "平台",
      value: "PLATFORM",
    },
    {
      label: "服务商",
      value: "AGENT",
    },
  ],
  SERVICEDRAW_TYPE: [
    {
      label: "定额",
      value: "AMOUNT",
    },
    {
      label: "百分比",
      value: "PERCENT",
    },
  ],
  SERVICEDRAW_PROMOTER_TYPE: [
    {
      label: "工程师",
      value: "JOINS_ENGINEER",
    },
    {
      label: "商户",
      value: "JOINS_MERCHANT",
    },
    {
      label: "推广员",
      value: "JOINS_PROMOTION_SPECIALIST",
    },
  ],
  SERVICE_WARRANTY_DATE_TYPE: [
    {
      label: "年",
      value: "YEAR",
    },
    {
      label: "月",
      value: "MONTH",
    },
    {
      label: "日",
      value: "DAY",
    },
  ],
  SMS_TEMPLATE_TYPE: [
    {
      label: "验证码",
      value: "ALI_VERIFY_CODE",
    },
    {
      label: "短信通知",
      value: "ALI_NOTICE_CODE",
    },
    {
      label: "推广短信",
      value: "ALI_PROMOTE_CODE",
    },
    {
      label: "国际/港澳台消息",
      value: "ALI_INTERNATIONAL_CODE",
    },
  ],
  SMS_TEMPLATE_USE_TYPE: [
    {
      label: "系统使用",
      value: "USE_SYSTEM",
    },
    {
      label: "其他",
      value: "USE_OTHER",
    },
  ],
  SMS_TEMPLATE_STATUS: [
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "无效",
      value: "INVALID",
    },
    {
      label: "审核未通过",
      value: "FAILED",
    },
  ],
  CONTROL_TYPE: [
    {
      label: "整数输入文本框",
      value: "INT_INPUT",
    },
    {
      label: "小数输入文本框",
      value: "FLOAT_INPUT",
    },
    {
      label: "输入文本框",
      value: "INPUT",
    },
    {
      label: "图片",
      value: "PICTURE",
    },
    {
      label: "选择时间",
      value: "TIME",
    },
    {
      label: "选择日期",
      value: "DATE",
    },
    {
      label: "选择日期和时间",
      value: "DATE_TIME",
    },
    {
      label: "单选",
      value: "RADIO",
    },
    {
      label: "多选",
      value: "CHECKBOX",
    },
    {
      label: "单选服务工程师",
      value: "SELECT_ENGINEER",
    },
    {
      label: "多选服务工程师",
      value: "MULTIPLE_SELECT_ENGINEER",
    },
    {
      label: "选择地址",
      value: "ADDRESS",
    },
  ],
  SHIPMENT_TYPE: [
    {
      label: "普通商品",
      value: "GENERAL_GOODS",
    },
    {
      label: "工程采购商品",
      value: "PROJECT_PROCUREMENT_GOODS",
    },
  ],
  SHOP_TYPE: [
    {
      label: "普通商品",
      value: "NORMAL",
    },
    {
      label: "工程采购商品",
      value: "ENGINEER",
    },
  ],
  DETAIL_TYPE: [
    {
      label: "消费",
      value: "CONSUME",
    },
    {
      label: "发放",
      value: "GRANT",
    },
    {
      label: "发放回滚",
      value: "GRANT_BACK",
    },
    {
      label: "消费回滚",
      value: "CONSUME_BACK",
    },
  ],
  DETAIL_STATUS_TYPE: [
    {
      label: "已过期",
      value: "EXPIRED",
    },
    {
      label: "失效",
      value: "FAILURE",
    },
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "退还",
      value: "REFUND",
    },
    {
      label: "冻结",
      value: "FREEZE",
    },
  ],
  USE_STATUS: [
    {
      label: "未使用",
      value: "NOT_USED",
    },
    {
      label: "已使用",
      value: "USED",
    },
  ],
  CARD_STATUS: [
    {
      label: "正常",
      value: "NORMAL",
    },
    {
      label: "已作废",
      value: "VOIDED",
    },
  ],
  WORK_ORDER_TYPE: [
    {
      label: "业主",
      value: "OWNER",
    },
    {
      label: "水电工",
      value: "WIRE_MAN",
    },
    {
      label: "工长",
      value: "FOREMAN",
    },
    {
      label: "项目经理",
      value: "PROJECT_MANAGER",
    },
    {
      label: "经销商",
      value: "DEALER",
    },
    {
      label: "装修商",
      value: "DECORATOR",
    },
  ],
  SIGINING_TYPE: [
    {
      label: "全包工程",
      value: "全包工程",
    },
    {
      label: "分包工程",
      value: "分包工程",
    },
    {
      label: "双包工程",
      value: "双包工程",
    },
    {
      label: "外包工程",
      value: "外包工程",
    },
  ],
  SYSTEM_TYPES: [
    {
      label: "明装暖气片",
      value: "明装暖气片",
    },
    {
      label: "暗埋暖气片",
      value: "暗埋暖气片",
    },
    {
      label: "地暖",
      value: "地暖",
    },
    {
      label: "新风",
      value: "新风",
    },
    {
      label: "净水",
      value: "净水",
    },
    {
      label: "空调",
      value: "空调",
    },
    {
      label: "锅炉",
      value: "锅炉",
    },
  ],
  SIGIN_CONTRACT: [
    {
      label: "是",
      value: "是",
    },
    {
      label: "否",
      value: "否",
    },
  ],
  CONSTRUCTION_SCHEDULING: [
    {
      label: "进行中",
      value: "进行中",
    },
    {
      label: "已完成",
      value: "已完成",
    },
  ],
  REPORTING: [
    {
      label: "是",
      value: "是",
    },
    {
      label: "否",
      value: "否",
    },
  ],
  // 质保期WARRANTY_PERIOD
  WARRANTY_PERIOD: [
    {
      label: "2年",
      value: "2年",
    },
    {
      label: "3年",
      value: "3年",
    },
    {
      label: "5年",
      value: "5年",
    },
    {
      label: "6年",
      value: "6年",
    },
    {
      label: "7年",
      value: "7年",
    },
    {
      label: "8年",
      value: "8年",
    },
    {
      label: "9年",
      value: "9年",
    },
    {
      label: "10年",
      value: "10年",
    },
    {
      label: "50年",
      value: "50年",
    },
  ],
  IS_CONTACT: [
    {
      label: "是",
      value: "YES",
    },
    {
      label: "否",
      value: "NO",
    },
  ],
  REBATE_STATUS: [
    {
      label: "待审核",
      value: "WAIT_AUDIT",
    },

    {
      label: "正常",
      value: "SUCCESS",
    },
    {
      label: "待指派",
      value: "WAIT_FOR_ASSIGN",
    },
    {
      label: "施工中",
      value: "IN_SERVICE",
    },
    {
      label: "已完成",
      value: "SOLVE",
    },
    {
      label: "已完成",
      value: "COMPLETE",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
  ],
  ORDER_WATER_STATUS: [
    {
      label: "待付款",
      value: "WAIT_PAY",
    },
    {
      label: "待指派",
      value: "WAIT_FOR_ASSIGN",
    },
    {
      label: "服务中",
      value: "IN_SERVICE",
    },
    {
      label: "待提货",
      value: "WAIT_FOR_DELIVERY",
    },
    {
      label: "待安装",
      value: "WAIT_INSTALL",
    },
    {
      label: "部分安装",
      value: "PARTIAL_INSTALLATION",
    },
    {
      label: "延迟安装",
      value: "NOT_INSTALLED",
    },
    {
      label: "已退回",
      value: "BACK",
    },
    {
      label: "待评价",
      value: "TO_BE_EVALUATED",
    },
    {
      label: "完成",
      value: "COMPLETE",
    },
    {
      label: "完成",
      value: "SOLVE",
    },
    {
      label: "部分退款",
      value: "PARTIAL_REFUND",
    },
    {
      label: "已退款",
      value: "REFUND_PAY",
    },
    {
      label: "待终审",
      value: "TO_BE_THE_FINAL",
    },
  ],
};
